import { BookmarkPlus, Sparkles, Search } from "lucide-react";

export const HowItWorksSection = () => (
  <section className="flex items-start justify-center py-10 md:py-20 lg:py-28 relative w-full bg-brand-500/[0.04]">
    <div className="page-frame">
      <div className="flex flex-col gap-8 md:gap-12">
        <h2 className="font-semibold leading-none text-display-28 sm:text-display-40 md:text-display-52 lg:text-display-64 tracking-[-0.84px] sm:tracking-[-1.2px] md:tracking-[-1.56px] lg:tracking-[-1.92px] text-foreground text-center">
          How it <span className="text-brand-500">works</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-[1100px] mx-auto w-full">
          <div className="flex flex-col gap-3 items-center text-center">
            <div className="rounded-2xl bg-brand-500/10 text-brand-500 p-3">
              <BookmarkPlus className="w-6 h-6" />
            </div>
            <h3 className="text-lg md:text-xl font-semibold text-foreground">
              Save from anywhere
            </h3>
            <p
              className="text-sm md:text-base text-foreground/70 leading-normal"
              style={{ fontVariationSettings: "'opsz' 14" }}
            >
              Stash posts, screenshots, videos, and links from Instagram, TikTok, X, YouTube, Pinterest, and the web.
            </p>
          </div>
          <div className="flex flex-col gap-3 items-center text-center">
            <div className="rounded-2xl bg-brand-500/10 text-brand-500 p-3">
              <Sparkles className="w-6 h-6" />
            </div>
            <h3 className="text-lg md:text-xl font-semibold text-foreground">
              Let Stasht pull out the details
            </h3>
            <p
              className="text-sm md:text-base text-foreground/70 leading-normal"
              style={{ fontVariationSettings: "'opsz' 14" }}
            >
              Places, dates, recipes, products, text on screen, and speech in videos become useful, searchable cards.
            </p>
          </div>
          <div className="flex flex-col gap-3 items-center text-center">
            <div className="rounded-2xl bg-brand-500/10 text-brand-500 p-3">
              <Search className="w-6 h-6" />
            </div>
            <h3 className="text-lg md:text-xl font-semibold text-foreground">
              Find it when you need it
            </h3>
            <p
              className="text-sm md:text-base text-foreground/70 leading-normal"
              style={{ fontVariationSettings: "'opsz' 14" }}
            >
              Restaurants show up on your map, events fit your calendar flow, and reminders bring saves back on time.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);
